import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Container from 'components/Container';
import PostCard from 'components/PostCard';
import { PostShape } from 'utils/props';

const Section = styled.section`
  padding: 4rem 1rem;
`;

const PostGrid = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
  grid-auto-rows: 1fr;
  align-items: stretch;
  gap: 1rem;
`;

const Card = styled(PostCard)`
  width: 100%;
`;

function SubCategoryPostGrid({ posts }) {
  return (
    <Section>
      <Container>
        <PostGrid role="list">
          {posts.map((post) => (
            <Card
              forwardedAs="li"
              image={post.featureImage}
              key={post.slug}
              link={`/post/${post.slug}`}
              title={post.title}
            />
          ))}
        </PostGrid>
      </Container>
    </Section>
  );
}

export default SubCategoryPostGrid;

SubCategoryPostGrid.propTypes = {
  posts: PropTypes.arrayOf(PostShape),
};
